(function() {
  'use strict';

  angular.module('app.parcels')
    .controller('LettersCtrl', LettersCtrl);

  /** @ngInject */
  function LettersCtrl($templateCache, $window, sessionService, $rootScope, $scope, $filter, $document, $state, $uibModal, maps, NgTableParams, Parcels, Reports, esriLoader, tracts, appConfig) {
    let vm = this;
    // exporting letters busy
    vm.exporting = false;

    // don't show any input fields by default
    vm.parcelTractSwitch = false;
    vm.showTaxStatus = false;
    vm.showBoardStatus = false;
    vm.showProposedSale = false;
    vm.showDNRResponse = false;
    vm.showCityResponse = false;
    vm.showForfeitDate = false;
    vm.showTract = false;
    vm.showLastLSDate = false;
    vm.showPolSub = false;
    vm.showInspect = false;
    vm.showOwnerLtrPrinted = false;

    vm.lettertype = '';
    vm.polSub = 'cityortownship';

    // watch for the bulk field list change
    $scope.$on('letters-changed', function(event, data) {
      vm.letterTypes = _filterByFieldValue(data);
    });

    vm.letterTitle = 'Choose a letter type';

    // letter type to generate
    vm.letterTypeToGenerate;

    vm.letterTypes = [];

    let allLetterTypes = [{
        name: 'DNR Future Direct Sales Letter',
        value: 'dnrfutureletter',
        layer: 'Parcels',
        searchFields : ['TaxForfeitedStatus', 'Board_Class_Action', 'ProposedSaleType', 'DNRResponse', 'Forfeiture_date'],
        query: 'TaxForfeitedStatus = \'Active\' AND Board_Class_Action IS NULL AND DNRResponse IS NULL AND Forfeiture_date < date (CurrentDate - 6 months) AND ProposedSaleType = \'Direct Sale\''
      }, {
        name: 'DNR Future Public Auction Letter',
        value: 'dnrfutureauction',
        layer: 'Parcels',
        searchFields: ['TaxForfeitedStatus', 'Board_Class_Action', 'ProposedSaleType', 'DNRResponse', 'Tract'],
        query: 'TaxForfeitedStatus = \'Active\' AND ProposedSaleType = \'Auction\''
        // query: 'TaxForfeitedStatus = \'Active\' AND Board_Class_Action IS NULL AND DNRResponse IS NULL AND Forfeiture_date < (CurrentDate - 6 months) AND ProposedSaleType = \'Auction\''
      },
      {
        name: 'DNR Land Sale List Letter',
        value: 'dnrlandsalelist',
        layer: 'Tracts',
        searchFields: ['TaxForfeitedStatus', 'ProposedSaleType', 'Last_LS_date', 'Tract'],
        query: 'ProposedSaleType = \'Auction\' AND TaxForfeitedStatus = \'Active\' AND Tract IS NOT NULL AND Last_LS_date > date \'Current Date\''
      },
      {
        name: 'Direct Land Sale Letter of Interest',
        value: 'adjacentletter',
        layer: 'Parcels',
        searchFields: ['TaxForfeitedStatus', 'ProposedSaleType'],
        query: 'ProposedSaleType = \'Direct Sale\' AND TaxForfeitedStatus = \'Active\''
      }, {
        name: '120-foot Radius Notification Letter',
        value: 'radiusletter',
        layer: 'Tracts',
        searchFields: ['Last_LS_date'],
        query: 'Last_LS_date > the date today'
      }, {
        name: 'Classification Letter to City for Public Auction',
        value: 'classLetter',
        layer: 'Parcels',
        searchFields: ['TaxForfeitedStatus', 'Board_Class_Action', 'ProposedSaleType', 'CityTwpResponse', 'Political_Sub'],
        query: 'TaxForfeitedStatus = \'Active\' AND ProposedSaleType = \'Auction\' AND (Political_Sub LIKE \'%CITY%\' OR Political_Sub LIKE \'%TOWNSHIP%\')'
        // query: 'TaxForfeitedStatus = \'Active\' AND Board_Class_Action IS NULL AND CityTwpResponse IS NULL AND (Political_Sub LIKE \'%CITY%\' OR Political_Sub LIKE \'%TOWNSHIP%\') AND ProposedSaleType = \'Auction\''
      }, {
        name: 'Classification Letter to City for Direct Sale',
        value: 'citydirectsale',
        layer: 'Parcel',
        searchFields: ['TaxForfeitedStatus', 'Board_Class_Action', 'ProposedSaleType', 'CityTwpResponse', 'Political_Sub'],
        query: 'TaxForfeitedStatus = \'Active\' AND Board_Class_Action IS NULL AND CityTwpResponse IS NULL AND (Political_Sub LIKE \'%CITY%\' OR Political_Sub LIKE \'%TOWNSHIP%\') AND ProposedSaleType = \'Direct Sale\''
      }, {
        name: 'Owner Tax Forfeit Notification Letter',
        value: 'ownerletter',
        layer: 'Parcels',
        searchFields: ['TaxForfeitedStatus', 'Board_Class_Action', 'InspectionStatus', 'Tract', 'OwnerLetterPrinted'],
        query: 'TaxForfeitedStatus = \'Active\' AND Board_Class_Action IS NULL AND InspectionStatus = \'Needs Inspection\' AND Tract IS NULL AND OwnerLetterPrinted IS NULL'
      }
    ];

    let allFields = [{
      field: 'TaxForfeitedStatus',
      value: '',
      domValue: 'forfeitStatus',
      isDate: false
    },{
      field: 'Board_Class_Action',
      value: '',
      domValue: 'board',
      isDate: false
    },{
      field: 'ProposedSaleType',
      value:'',
      domValue: 'proposed',
      isDate: false
    },{
      field: 'DNRResponse',
      value: '',
      domValue: 'dnrresponse',
      isDate: false
    },{
      field: 'CityTwpResponse',
      value: '',
      domValue: 'cityresponse',
      isDate: false
    },{
      field: 'Political_Sub',
      value: '',
      domValue: 'polSub',
      isDate: false
    },{
      field: 'Forfeiture_date',
      value: '',
      domValue: 'forfeitDate',
      isDate: true
    },{
      field: 'Last_LS_date',
      value: '',
      domValue: 'landsaleDate',
      isDate: true
    },{
      field: 'InspectionStatus',
      value: '',
      domValue: 'inspection',
      isDate: false
    },{
      field: 'Tract',
      value: '',
      domValue: 'tract',
      isDate: false
    },{
      field: 'OwnerLetterPrinted',
      value: '',
      domValue: 'ownerLetterPrinted',
      isDate: false
    }];

    vm.auctionDate = 'Choose date';
    vm.dateFormat = 'MM/dd/yyyy';
    vm.auctionDates = [];
    Parcels.getFutureAuctionDates(false).then(function(allAuctionDates) {
      vm.auctionDates = allAuctionDates;
    });

    vm.forfdatecal= {
      opened: false
    };

    vm.lsdatecal= {
      opened: false
    };

    vm.openForfCal = function() {
      vm.forfdatecal.opened = true;
    };

    vm.openLSCal = function() {
      vm.lsdatecal.opened = true;
    };

    vm.setDate = function(date) {
      vm.auctionDate = date;
      vm.radiusdate = date;
    };

    vm.letterFormat = function() {
      vm.letterTypeToGenerate = _.find(vm.letterTypes, {
        'name': vm.lettertype
      });
      let query = {};
      let today = new Date();
      console.log('Letter: ', vm.letterTypeToGenerate.value);
      switch (vm.letterTypeToGenerate.value) {
        case 'adjacentletter':
          maps.clearAdminFilter();
          $rootScope.$broadcast('set-query-indicator', {
            value: true
          });
          vm.radius = false;
          vm.parcelTractSwitch = false;
          vm.showTaxStatus = true;
          vm.showBoardStatus = false;
          vm.showProposedSale = true;
          vm.showDNRResponse = false;
          vm.showCityResponse = false;
          vm.showForfeitDate = false;
          vm.showTract = false;
          vm.showLastLSDate = false;
          vm.showPolSub = false;
          vm.showInspect = false;
          vm.showOwnerLtrPrinted = false;
          // set defaults
          vm.forfeitStatus = 'Active';
          vm.proposed = 'Direct Sale';
          query = {
            lastDate: ''
          };
          query.lastDate = 'TaxForfeitedStatus = \'Active\' AND ProposedSaleType = \'Direct Sale\'';
          maps.adminFilterProperties(query);
          // refresh the parcels in the table
          Parcels.list(false);
          break;
        case 'radiusletter':
          maps.clearAdminFilter();
          $rootScope.$broadcast('set-query-indicator', {
            value: true
          });
          vm.radius = true;
          vm.parcelTractSwitch = false;
          vm.showTaxStatus = false;
          vm.showBoardStatus = false;
          vm.showProposedSale = false;
          vm.showDNRResponse = false;
          vm.showCityResponse = false;
          vm.showForfeitDate = false;
          vm.showTract = false;
          vm.showLastLSDate = true;
          vm.showPolSub = false;
          vm.showInspect = false;
          vm.showOwnerLtrPrinted = false;
          // set defaults
          vm.landsaleDate = today;
          query = {
            lastDate: ''
          };
          query.lastDate = 'Last_LS_date > date \'' + (today.getMonth() + 1) + '/' + today.getDate() + '/' + today.getFullYear() + '\'';
          maps.adminFilterProperties(query);
          // refresh the TRACTS in the table
          Parcels.list(true);
          break;
        case 'dnrfutureletter':
          maps.clearAdminFilter();
          $rootScope.$broadcast('set-query-indicator', {
            value: true
          });
          vm.radius = false;
          vm.parcelTractSwitch = false;
          vm.showTaxStatus = true;
          vm.showBoardStatus = true;
          vm.showProposedSale = true;
          vm.showDNRResponse = true;
          vm.showCityResponse = false;
          vm.showForfeitDate = true;
          vm.showTract = false;
          vm.showLastLSDate = false;
          vm.showPolSub = false;
          vm.showInspect = false;
          vm.showOwnerLtrPrinted = false;
          today.setMonth(today.getMonth() - 6);
          // set defaults
          vm.forfeitDate = today; // six months ago
          vm.forfeitStatus = 'Active';
          vm.board = null;
          vm.dnrresponse = null;
          vm.proposed = 'Direct Sale';
          query = {
            ProposedSaleType: ''
          };
          query.lastDate = 'TaxForfeitedStatus = \'Active\' AND Board_Class_Action IS NULL AND DNRResponse IS NULL AND Forfeiture_date <= date \'' + (today.getMonth() + 1) + '/' + today.getDate() + '/' + today.getFullYear() + '\' AND ProposedSaleType = \'Direct Sale\'';
          // maps.setLettersQuery(query.lastDate);
          maps.adminFilterProperties(query);
          // refresh the parcels
          Parcels.list(false);
          break;
        case 'dnrfutureauction':
          maps.clearAdminFilter();
          $rootScope.$broadcast('set-query-indicator', {
            value: true
          });
          vm.radius = false;
          vm.parcelTractSwitch = true;
          vm.showTaxStatus = true;
          vm.showBoardStatus = true;
          vm.showProposedSale = true;
          vm.showDNRResponse = true;
          vm.showCityResponse = false;
          vm.showForfeitDate = false;
          vm.showTract = true;
          vm.showLastLSDate = false;
          vm.showPolSub = false;
          vm.showInspect = false;
          vm.showOwnerLtrPrinted = false;
          today.setMonth(today.getMonth() - 6);
          // set defaults
          vm.parcelOrTract = 'parcels';
          vm.forfeitDate = today; // six months ago
          vm.forfeitStatus = 'Active';
          vm.board = null;
          vm.dnrresponse = null;
          vm.proposed = 'Auction';

          query = {
            ProposedSaleType: ''
          };
          // query.lastDate = 'TaxForfeitedStatus = \'Active\' AND ProposedSaleType = \'Auction\'';
          query.lastDate = 'TaxForfeitedStatus = \'Active\' AND Board_Class_Action IS NULL AND DNRResponse IS NULL AND Tract IS NULL AND ProposedSaleType = \'Auction\'';
          maps.adminFilterProperties(query);
          // refresh the PARCELS in the table
          Parcels.list(false);
          break;
        case 'classLetter':
          maps.clearAdminFilter();
          $rootScope.$broadcast('set-query-indicator', {
            value: true
          });
          vm.radius = false;
          vm.parcelTractSwitch = true;
          vm.showTaxStatus = true;
          vm.showBoardStatus = true;
          vm.showProposedSale = true;
          vm.showDNRResponse = false;
          vm.showCityResponse = true;
          vm.showForfeitDate = false;
          vm.showTract = false;
          vm.showLastLSDate = false;
          vm.showPolSub = true;
          vm.showInspect = false;
          vm.showOwnerLtrPrinted = false;
          // set defaults
          vm.parcelOrTract = 'parcels';
          vm.forfeitStatus = 'Active';
          vm.proposed = 'Auction';
          vm.polSub = '';
          vm.board = null;
          vm.cityresponse = null;
          query = {
            ProposedSaleType: ''
          };
          // query.lastDate = 'TaxForfeitedStatus = \'Active\' AND ProposedSaleType = \'Auction\' AND (Political_Sub LIKE \'%CITY%\' OR Political_Sub LIKE \'%TOWNSHIP%\')';
          query.lastDate = 'TaxForfeitedStatus = \'Active\' AND Board_Class_Action IS NULL AND CityTwpResponse IS NULL AND (Political_Sub LIKE \'%CITY%\' OR Political_Sub LIKE \'%TOWNSHIP%\') AND ProposedSaleType = \'Auction\'';
          maps.adminFilterProperties(query);
          // refresh the PARCELS in the table
          Parcels.list(false);
          break;
        case 'citydirectsale':
          maps.clearAdminFilter();
          $rootScope.$broadcast('set-query-indicator', {
            value: true
          });
          vm.radius = false;
          vm.parcelTractSwitch = false;
          vm.showTaxStatus = true;
          vm.showBoardStatus = true;
          vm.showProposedSale = true;
          vm.showDNRResponse = false;
          vm.showCityResponse = true;
          vm.showForfeitDate = false;
          vm.showTract = false;
          vm.showLastLSDate = false;
          vm.showPolSub = true;
          vm.showInspect = false;
          vm.showOwnerLtrPrinted = false;
          // set defaults
          vm.forfeitStatus = 'Active';
          vm.board = null;
          vm.cityresponse = null;
          vm.polSub = '';
          vm.proposed = 'Direct Sale';
          query = {
            ProposedSaleType: ''
          };
          query.lastDate = 'TaxForfeitedStatus = \'Active\' AND Board_Class_Action IS NULL AND CityTwpResponse IS NULL AND (Political_Sub LIKE \'%CITY%\' OR Political_Sub LIKE \'%TOWNSHIP%\') AND ProposedSaleType = \'Direct Sale\'';
          maps.adminFilterProperties(query);
          // refresh the PARCELS in the table
          Parcels.list(false);
          break;
        case 'ownerletter':
          maps.clearAdminFilter();
          vm.radius = false;
          vm.parcelTractSwitch = false;
          vm.showTaxStatus = true;
          vm.showBoardStatus = true;
          vm.showProposedSale = false;
          vm.showDNRResponse = false;
          vm.showCityResponse = false;
          vm.showForfeitDate = false;
          vm.showTract = true;
          vm.showLastLSDate = false;
          vm.showPolSub = false;
          vm.showInspect = true;
          vm.showOwnerLtrPrinted = true;
          // set defaults
          vm.forfeitStatus = 'Active';
          vm.board = '';
          vm.inspection = 'Needs Inspection';
          break;
        case 'dnrlandsalelist':
          maps.clearAdminFilter();
          $rootScope.$broadcast('set-query-indicator', {
            value: true
          });
          vm.radius = false;
          vm.parcelTractSwitch = true;
          vm.showTaxStatus = false;
          vm.showBoardStatus = false;
          vm.showProposedSale = true;
          vm.showDNRResponse = false;
          vm.showCityResponse = false;
          vm.showForfeitDate = false;
          vm.showTract = true;
          vm.showLastLSDate = true;
          vm.showPolSub = false;
          vm.showInspect = false;
          vm.showOwnerLtrPrinted = false;
          // today.setMonth(today.getMonth() - 6);
          // set defaults
          vm.parcelOrTract = 'tracts';
          vm.forfeitStatus = 'Active';
          vm.proposed = 'Auction';
          // vm.forfeitDate = today; // six months ago
          vm.landsaleDate = new Date();
          vm.tract = 'notnull';
          query = {
            ProposedSaleType: ''
          };
          query.lastDate = 'ProposedSaleType = \'Auction\' AND TaxForfeitedStatus = \'Active\' AND Last_LS_date >= date \'' + (today.getMonth() + 1) + '/' + today.getDate() + '/' + today.getFullYear() + '\' AND Tract IS NOT NULL';
          maps.adminFilterProperties(query);
          // refresh the TRACTS in the table
          Parcels.list(true);
          break;
      }
      if (vm.lettertype !== null) {
        vm.letterTitle = vm.lettertype;
        // vm.params.filetype = lettertype;
      } else {
        vm.letterTitle = 'Choose a letter type';
      }
    };

    vm.letterListQuery = function() {
      console.log('lettertype', vm.letterTypeToGenerate);
        let query = {};
      switch (vm.letterTypeToGenerate.value) {
        case 'dnrfutureletter':
          maps.clearAdminFilter();
          query = {
            ProposedSaleType: ''
          };
          // today.setMonth(today.getMonth() - 6);
          // query.lastDate = 'TaxForfeitedStatus = \'Active\' AND Board_Class_Action IS NULL AND DNRResponse IS NULL AND Forfeiture_date <= \'' + (today.getMonth() + 1) + '/' + today.getDate() + '/' + today.getFullYear() + '\' AND ProposedSaleType = \'Direct Sale\'';
          // maps.setLettersQuery(query.lastDate);
          query.lastDate = _constructLetterQuery(vm.letterTypeToGenerate.searchFields);
          maps.adminFilterProperties(query);
          // refresh the parcels
          Parcels.list(false);
          break;
        case 'dnrfutureauction':
          maps.clearAdminFilter();
          query = {
            ProposedSaleType: ''
          };
          // query.lastDate = 'TaxForfeitedStatus = \'Active\' AND Board_Class_Action IS NULL AND DNRResponse IS NULL AND Forfeiture_date <= \'' + (today.getMonth() + 1) + '/' + today.getDate() + '/' + today.getFullYear() + '\' AND ProposedSaleType = \'Auction\'';
          // let searchFields = [];
          if (vm.parcelOrTract === 'tracts') {
            vm.forfeitStatus = 'Active';
          } else if (vm.parcelOrTract === 'parcels') {
            // searchFields = vm.letterTypeToGenerate.searchFields;
          }
          query.lastDate = _constructLetterQuery(vm.letterTypeToGenerate.searchFields);
          maps.adminFilterProperties(query);
          // refresh the TRACTS (true) or PARCELS (false) in the table
          console.log(vm.parcelOrTract);
          vm.parcelOrTract === 'parcels' ? Parcels.list(false) : Parcels.list(true);
          // Parcels.list(true);
          break;
        case 'dnrlandsalelist':
          maps.clearAdminFilter();
          query = {
            ProposedSaleType: ''
          };
          query.lastDate = _constructLetterQuery(vm.letterTypeToGenerate.searchFields);
          maps.adminFilterProperties(query);
          // refresh the TRACTS (true) or PARCELS (false) in the table
          vm.parcelOrTract === 'parcels' ? Parcels.list(false) : Parcels.list(true);
          break;
        case 'adjacentletter':
          maps.clearAdminFilter();
          query = {
            lastDate: ''
          };
          // query.lastDate = 'TaxForfeitedStatus = \'Active\' AND ProposedSaleType = \'Direct Sale\'';
          query.lastDate = _constructLetterQuery(vm.letterTypeToGenerate.searchFields);
          maps.adminFilterProperties(query);
          // refresh the parcels in the table
          Parcels.list(false);
          break;
        case 'classLetter':
          maps.clearAdminFilter();
          query = {
            ProposedSaleType: ''
          };
          query.lastDate = _constructLetterQuery(vm.letterTypeToGenerate.searchFields);
          // query.lastDate = 'TaxForfeitedStatus = \'Active\' AND ProposedSaleType = \'Auction\' AND (Political_Sub LIKE \'%CITY%\' OR Political_Sub LIKE \'%TOWNSHIP%\')';
          // query.lastDate = 'TaxForfeitedStatus = \'Active\' AND Board_Class_Action IS NULL AND CityTwpResponse IS NULL AND (Political_Sub LIKE \'%CITY%\' OR Political_Sub LIKE \'%TOWNSHIP%\') AND ProposedSaleType = \'Auction\'';
          maps.adminFilterProperties(query);
          // refresh the TRACTS (true) or PARCELS (false) in the table
          console.log(vm.parcelOrTract);
          vm.parcelOrTract === 'parcels' ? Parcels.list(false) : Parcels.list(true);
          // Parcels.list(false);
          break;
        case 'citydirectsale':
          maps.clearAdminFilter();
          query = {
            ProposedSaleType: ''
          };
          query.lastDate = _constructLetterQuery(vm.letterTypeToGenerate.searchFields);
          // query.lastDate = 'TaxForfeitedStatus = \'Active\' AND Board_Class_Action IS NULL AND CityTwpResponse IS NULL AND (Political_Sub LIKE \'%CITY%\' OR Political_Sub LIKE \'%TOWNSHIP%\') AND ProposedSaleType = \'Direct Sale\'';
          maps.adminFilterProperties(query);
          // refresh the TRACTS in the table
          Parcels.list(false);
          break;
        case 'ownerletter':
          maps.clearAdminFilter();
          query = {
            lastDate: ''
          };
          // query.lastDate = 'Last_LS_date > \'' + (today.getMonth() + 1) + '/' + today.getDate() + '/' + today.getFullYear() + '\'';
          query.lastDate = _constructLetterQuery(vm.letterTypeToGenerate.searchFields);
          maps.adminFilterProperties(query);
          // refresh the PARCELS in the table
          Parcels.list(false);
          break;
        case 'radiusletter':
          maps.clearAdminFilter();
          query = {
            lastDate: ''
          };
          // query.lastDate = 'Last_LS_date > \'' + (today.getMonth() + 1) + '/' + today.getDate() + '/' + today.getFullYear() + '\'';
          query.lastDate = _constructLetterQuery(vm.letterTypeToGenerate.searchFields);
          maps.adminFilterProperties(query);
          // refresh the TRACTS in the table
          Parcels.list(true);
          break;
        default:
      }

    };

    vm.generateletter = function() {
      vm.exporting = true;
      // letter type to generate
      console.log('Generate: ', vm.letterTypeToGenerate.value);
      vm[vm.letterTypeToGenerate.value]();
    };

    // TODO: consider moving this over to the reports factory for re-use in other areas of the app
    vm.dnrlandsalelist = function() {
      esriLoader.require([
        'esri/layers/FeatureLayer',
        'esri/tasks/query'
      ], function(
        FeatureLayer,
        Query
      ) {
        // find the number of tracts that are available for review
        let query = new Query();
        // let today = new Date();
        let allTractIds = [];
        let allParcels = Parcels.getParcels();
        if (allParcels.length === 0) {
          alert('There are no features to generate this letter for.');
          vm.exporting = false;
        } else {
        // console.log('allParcels', allParcels);
          if (vm.parcelOrTract === 'tracts') {
            console.log('query tracts');
          // construct the query for the tracts based on the parcel Tract ID available at this step
            for (let i = 0; i < allParcels.length; i++) {
              allTractIds.push('\'' + allParcels[i].attributes.Tract + '\'');
            }
            allTractIds = _.uniqWith(allTractIds, _.isEqual);
            let tractsQuery = 'Tract IN (' + allTractIds.join(',') + ')';
            // query.where = 'ProposedSaleType = \'Auction\' AND Last_LS_date > \'1/1/' + today.getFullYear() + '\' AND Last_LS_date < \'12/31/' + today.getFullYear() + '\'';
            query.where = tractsQuery;
            query.returnGeometry = false;
            // get the tracts layers
            let tractsLayer = tracts.getLayer();
            if (tractsLayer == null) {
              tractsLayer = new FeatureLayer(appConfig.getConfig().tractsUrl);
            } else {
              tractsLayer.setDefinitionExpression(null);
            }

            tractsLayer.queryCount(query, function(count) {
              console.log(count + ' features to report on the land sale list');
              let params = {};
              params.count = count;
              params.background = 'Crow_Wing_Letter_Head.png';
              Reports.generate('dnrletter', params).then(function(results) {
                // console.log('results', results);
                vm.exporting = false;
                $window.open(results);
              });
            }, function(error) {
              console.log(error);
            });
        } else if (vm.parcelOrTract === 'parcels') {
          console.log('query Parcels');
          let allParcelIds = [];
          for (let i = 0; i < allParcels.length; i++) {
            allParcelIds.push('\'' + allParcels[i].attributes.PIN + '\'');
          }
          // allTractIds = _.uniqWith(allTractIds, _.isEqual);
          let parcelsQuery = 'PIN IN (' + allParcelIds.join(',') + ')';
          // query.where = 'ProposedSaleType = \'Auction\' AND Last_LS_date > \'1/1/' + today.getFullYear() + '\' AND Last_LS_date < \'12/31/' + today.getFullYear() + '\'';
          query.where = parcelsQuery;
          query.returnGeometry = false;
          // get the tracts layers
          let parcelsLayer = maps.getFilterLayer();
          if (parcelsLayer == null) {
            parcelsLayer = new FeatureLayer(appConfig.getConfig().parcelsUrl);
          }
          parcelsLayer.queryCount(query, function(count) {
            console.log(count + ' features to report on the land sale list');
            let params = {};
            params.count = count;
            params.background = 'Crow_Wing_Letter_Head.png';
            Reports.generate('dnrletter', params).then(function(results) {
              // console.log('results', results);
              vm.exporting = false;
              $window.open(results);
            });
          }, function(error) {
            console.log(error);
          });

        }
      }
      });
    };

    // TODO: consider moving this over to the reports factory for re-use in other areas of the app
    // DNR DIRECT SALE letter
    vm.dnrfutureletter = function() {
      esriLoader.require([
        'esri/layers/FeatureLayer',
        'esri/tasks/query'
      ], function(
        FeatureLayer,
        Query
      ) {
        // find the number of tracts that are available for review
        let query = new Query();
        query.returnGeometry = false;
        query.outFields = ['*'];
        // DNR Future Sales Letter query
        // let today = new Date();
        // today.setMonth(today.getMonth() - 6);
        // query.where = 'TaxForfeitedStatus = \'Active\' AND (Board_Class_Action IS NULL OR Board_Class_Action = \'Non-Conservation\') AND DNRResponse IS NULL AND Forfeiture_date <= \'' + (today.getMonth() + 1) + '/' + today.getDate() + '/' + today.getFullYear() + '\' AND ProposedSaleType = \'Direct Sale\'';
        query.where = _constructLetterQuery(vm.letterTypeToGenerate.searchFields);
        // console.log('letter query:', query.where);
        // get the parcels layers
          let parcelsLayer = maps.getFilterLayer();
          if (parcelsLayer == null) {
            parcelsLayer = new FeatureLayer(appConfig.getConfig().parcelsUrl);
          }

        parcelsLayer.queryFeatures(query, function(results) {
          if (results.features.length === 0) {
            vm.exporting = false;
            setTimeout(function() {
              $scope.$apply();
              alert('There are no features to generate this letter for.');
            }, 200);
          } else {
            let reportFeatures = [];
            for (let id in results.features) {
              reportFeatures.push(results.features[id].attributes);
            }
            let background = 'Crow_Wing_Letter_Head.png';
            Reports.dnrfutureletter(reportFeatures, background).then(function(results) {
              // console.log('results', results);
              vm.exporting = false;
              $window.open(results);
            });
          }
        }, function(error) {
          console.log(error);
        });
      });
    };

    vm.dnrfutureauction = function() {
      esriLoader.require([
        'esri/layers/FeatureLayer',
        'esri/tasks/query'
      ], function(
        FeatureLayer,
        Query
      ) {
        // find the number of parcels that are available for review
        let query = new Query();
        query.returnGeometry = false;
        query.outFields = ['*'];
        // DNR Future Sales Letter query
        // let today = new Date();
        // today.setMonth(today.getMonth() - 6);
        // query.where = _constructLetterQuery(vm.letterTypeToGenerate.searchFields);
        // query.where = 'TaxForfeitedStatus = \'Active\' AND ProposedSaleType = \'Auction\'';
        // query.where = 'TaxForfeitedStatus = \'Active\' AND Board_Class_Action IS NULL AND DNRResponse IS NULL AND Forfeiture_date <= \'' + (today.getMonth() + 1) + '/' + today.getDate() + '/' + today.getFullYear() + '\' AND ProposedSaleType = \'Auction\'';
        // get the parcels layers
        let parcelsLayer = maps.getFilterLayer();
        if (parcelsLayer == null) {
          parcelsLayer = new FeatureLayer(appConfig.getConfig().parcelsUrl);
        }
        console.log('vm.parcelOrTract:', vm.parcelOrTract);
        if (vm.parcelOrTract === 'parcels') {
          query.where = _constructLetterQuery(vm.letterTypeToGenerate.searchFields);
          console.log('query.where', query.where);
          parcelsLayer.queryFeatures(query, function(results) {
            console.log('results', results);
            if (results.features.length === 0) {
              vm.exporting = false;
              setTimeout(function() {
                $scope.$apply();
                alert('There are no features to generate this letter for.');
              }, 200);
            } else {
              let reportFeatures = [];
              for (let id in results.features) {
                reportFeatures.push(results.features[id].attributes);
              }
              let background = 'Crow_Wing_Letter_Head.png';
              Reports.dnrfutureauction(reportFeatures, background).then(function(results) {
                // console.log('results', results);
                vm.exporting = false;
                $window.open(results);
              });
            }
          }, function(error) {
            console.log(error);
          });

        } else if (vm.parcelOrTract === 'tracts') {
          let searchFields = ['Board_Class_Action', 'ProposedSaleType', 'DNRResponse', 'Tract'];
          query.where = _constructLetterQuery(searchFields);
          console.log('query.where', query.where);
          let tractsLayer = tracts.getLayer();
          if (tractsLayer == null) {
            tractsLayer = new FeatureLayer(appConfig.getConfig().tractsUrl);
          } else {
            tractsLayer.setDefinitionExpression(null);
          }
          tractsLayer.queryFeatures(query, function(results) {
            console.log('results', results);
            if (results.features.length === 0) {
              vm.exporting = false;
              setTimeout(function() {
                $scope.$apply();
                alert('There are no features to generate this letter for.');
              }, 200);
            } else {
              let reportFeatures = [];
              for (let id in results.features) {
                reportFeatures.push(results.features[id].attributes);
              }
              let background = 'Crow_Wing_Letter_Head.png';
              Reports.dnrfutureauction(reportFeatures, background).then(function(results) {
                // console.log('results', results);
                vm.exporting = false;
                $window.open(results);
              });
            }
          }, function(error) {
            console.log(error);
          });


          // first get parcels that satisfy search criteria
          // parcelsLayer.queryFeatures(query, function(results) {
          //   console.log('parcel results', results.features);
          //   if (results.features.length === 0) {
          //     vm.exporting = false;
          //     setTimeout(function() {
          //       $scope.$apply();
          //       alert('There are no features to generate this letter for.');
          //     }, 200);
          //   } else {
          //   let tractIDs = [];
          //   for (let i = 0; i < results.features.length; i++) {
          //     tractIDs.push('\'' + results.features[i].attributes.Tract + '\'');
          //   }
          //   tractIDs = _.uniqWith(tractIDs, _.isEqual);
          //   console.log('tractIDs', tractIDs);
          //   // find all the parcels that are in those tracts so we can make sure all their forfeiture dates satisfy the query
          //   let otherParcelsQuery = 'Tract IN (' + tractIDs.join(',') + ')';
          //   query.where = otherParcelsQuery;
          //   parcelsLayer.queryFeatures(query, function(results) {
          //     let allParcelsInTracts = results.features;
          //     console.log('all parcels in tracts', allParcelsInTracts);
          //     console.log('vm.forfeitDate', vm.forfeitDate);
          //     let excludeTracts = [];
          //     // if any constituent parcels have a forfeiture date after the query date, remove tract from tract list
          //     for (let i = 0; i < allParcelsInTracts.length; i++) {
          //       let parcelForfDate = _formatEsriDate(allParcelsInTracts[i].attributes.Forfeiture_date);
          //       // console.log('parcelForfDate', parcelForfDate);
          //       if (parcelForfDate > vm.forfeitDate) {
          //         console.log('out of range', parcelForfDate);
          //         excludeTracts.push('\'' + allParcelsInTracts[i].attributes.Tract + '\'');
          //       }
          //     }
          //     console.log('excludeTracts', excludeTracts);
          //     tractIDs = tractIDs.filter( function( el ) {
          //       return excludeTracts.indexOf( el ) < 0;
          //     } );
          //     console.log('TractIDs', tractIDs);
          //     // if no tracts, alert user
          //     if (tractIDs.length === 0) {
          //       vm.exporting = false;
          //       setTimeout(function() {
          //         $scope.$apply();
          //         alert('There are no features to generate this letter for.');
          //       }, 200);
          //     } else {
          //       query.where = 'Tract IN (' + tractIDs.join(',') + ')';
          //       console.log('query', query);
          //       tractsLayer.queryFeatures(query, function(results) {
          //         console.log('results', results);
          //         if (results.features.length === 0) {
          //           vm.exporting = false;
          //           setTimeout(function() {
          //             $scope.$apply();
          //             alert('There are no features to generate this letter for.');
          //           }, 200);
          //         } else {
          //           let reportFeatures = [];
          //           for (let id in results.features) {
          //             reportFeatures.push(results.features[id].attributes);
          //           }
          //           let background = 'Crow_Wing_Letter_Head.png';
          //           Reports.dnrfutureauction(reportFeatures, background).then(function(results) {
          //             // console.log('results', results);
          //             vm.exporting = false;
          //             $window.open(results);
          //           });
          //         }
          //       }, function(error) {
          //         console.log(error);
          //       });
          //     }
          //   });
          //   }
          // }, function(error) {
          //   console.log(error);
          // });
        }

      });
    };

    vm.ownerletter = function() {
      esriLoader.require([
        'esri/layers/FeatureLayer',
        'esri/tasks/query'
      ], function(
        FeatureLayer,
        Query
      ) {
        // find the number of tracts that are available for review
        let query = new Query();
        query.returnGeometry = false;
        query.outFields = ['*'];
        // let today = new Date();
        query.where = _ownerLetterQuery();

        // query.where = 'TaxForfeitedStatus = \'Active\' AND Board_Class_Action IS NULL AND InspectionStatus = \'Needs Inspection\' AND Tract IS NULL AND OwnerLetterPrinted IS NULL';
        // get the parcels layers
        let parcelsLayer = maps.getFilterLayer();
        if (parcelsLayer == null) {
          parcelsLayer = new FeatureLayer(appConfig.getConfig().parcelsUrl);
        }
        parcelsLayer.queryFeatures(query, function(results) {
          if (results.features.length === 0) {
            vm.exporting = false;
            setTimeout(function() {
              $scope.$apply();
              alert('There are no features to generate this letter for.');
            }, 200);
          } else {
            let objectIds = [];
            for (let i = 0; i < results.features.length; i++) {
              let feature = results.features[i];
              objectIds.push(feature.attributes.OBJECTID);
            }
            Reports.processOwnerNotice(results)
              .then(function(results) {
                // update the owner letter printed field to the current date
                Parcels.updateOwnerLetter(objectIds);
                vm.exporting = false;
                $window.open(results);
              });
          }
          // }
        }, function(error) {
          console.log(error);
        });
      });
    };

    vm.radiusletter = function() {
      esriLoader.require([
        'esri/layers/FeatureLayer',
        'esri/tasks/query'
      ], function(
        FeatureLayer,
        Query
      ) {
        // find the number of tracts that are available for review
        let query = new Query();
        // let today = new Date();
        query.returnGeometry = true;
        query.outFields = ['*'];
        // 120-ft Letter query
        // TODO: double check this date query
        // query.where = 'Last_LS_date > \'' + (today.getMonth() + 1) + '/' + today.getDate() + '/' + today.getFullYear() + '\'';
        query.where = _constructLetterQuery(vm.letterTypeToGenerate.searchFields);

        // get the tracts layers
        let tractsLayer = tracts.getLayer();
        if (tractsLayer == null) {
          tractsLayer = new FeatureLayer(appConfig.getConfig().tractsUrl);
        } else {
          tractsLayer.setDefinitionExpression(null);
        }
        // if (vm.radiusdate !== undefined) {
          tractsLayer.queryFeatures(query, function(results) {
            if (results.features.length === 0) {
              vm.exporting = false;
              setTimeout(function() {
                $scope.$apply();
                alert('There are no features to generate this letter');
              }, 200);
            } else {
              let bufferFt = 120,
                letterType = 'radius120ft';
              Reports.formatAdjacentLetterData(results, bufferFt, letterType).then(function(results) {
                vm.exporting = false;
                $window.open(results);
              });
            }
          }, function(error) {
            console.log(error);
          });
        // } else {
        //   vm.exporting = false;
        //   alert('No future auction dates available!');
        // }
      });
    };


    // Direct Land Sale Letter of Interest
    vm.adjacentletter = function() {
      esriLoader.require([
        'esri/layers/FeatureLayer',
        'esri/tasks/query'
      ], function(
        FeatureLayer,
        Query
      ) {
        // find the number of tracts that are available for review
        let query = new Query();
        query.returnGeometry = true;
        query.outFields = ['*'];
        // Adjacent Letter query
        let today = new Date();
        query.where = _constructLetterQuery(vm.letterTypeToGenerate.searchFields);
        // query.where = 'TaxForfeitedStatus = \'Active\' AND ProposedSaleType = \'Direct Sale\'';
        // get the parcels layers
        let parcelsLayer = maps.getFilterLayer();
        if (parcelsLayer == null) {
          parcelsLayer = new FeatureLayer(appConfig.getConfig().parcelsUrl);
        }

        parcelsLayer.queryFeatures(query, function(results) {
          if (results.features.length === 0) {
            vm.exporting = false;
            setTimeout(function() {
              $scope.$apply();
              alert('There are no features to generate this letter for.');
            }, 200);
          } else {
            let bufferFt = 5,
              letterType = 'adjacent';
            Reports.formatAdjacentLetterData(results, bufferFt, letterType).then(function(results) {
              vm.exporting = false;
              $window.open(results);
            });
          }
        }, function(error) {
          console.log(error);
        });
      });
    };

    // Classification Letter to City for Future Auction
    vm.classLetter = function() {
      esriLoader.require([
        'esri/layers/FeatureLayer',
        'esri/tasks/query'
      ], function(
        FeatureLayer,
        Query
      ) {
        let query = new Query();
        query.returnGeometry = false;
        query.outFields = ['*'];
        // let today = new Date();
        query.where = _constructLetterQuery(vm.letterTypeToGenerate.searchFields);
        // console.log('query.where', query.where);
        // query.where = 'TaxForfeitedStatus = \'Active\' AND ProposedSaleType = \'Auction\' AND (Political_Sub LIKE \'%CITY%\' OR Political_Sub LIKE \'%TOWNSHIP%\')';
        // query.where = 'TaxForfeitedStatus = \'Active\' AND Board_Class_Action IS NULL AND CityTwpResponse IS NULL AND (Political_Sub LIKE \'%CITY%\' OR Political_Sub LIKE \'%TOWNSHIP%\') AND ProposedSaleType = \'Auction\'';
        // get the parcels layers
        let parcelsLayer = maps.getFilterLayer();
        if (parcelsLayer == null) {
          parcelsLayer = new FeatureLayer(appConfig.getConfig().parcelsUrl);
        }
        // console.log(parcelsLayer);
        let tractsLayer = tracts.getLayer();
        if (tractsLayer == null) {
          tractsLayer = new FeatureLayer(appConfig.getConfig().tractsUrl);
        } else {
          tractsLayer.setDefinitionExpression(null);
        }

        parcelsLayer.queryFeatures(query, function(results) {
          console.log('parcel results', results);
          if (results.features.length === 0) {
            vm.exporting = false;
            setTimeout(function() {
              $scope.$apply();
              alert('There are no features to generate this letter for.');
            }, 200);
          } else {
            if (vm.parcelOrTract === 'parcels') {
              let saleType = 'Auction';
              Reports.processClassCities(results, saleType)
                .then(function(results) {
                  // console.log('results', results);
                  vm.exporting = false;
                  $window.open(results.letter);
                  $window.open(results.list);
                });
            } else if (vm.parcelOrTract === 'tracts') {
              let tractIDs = [];
              for (let i = 0; i < results.features.length; i++) {
                tractIDs.push('\'' + results.features[i].attributes.Tract + '\'');
              }
              tractIDs = _.uniqWith(tractIDs, _.isEqual);
              // console.log('tractIDs', tractIDs);
              // find all the parcels that are in those tracts so we can make sure all their forfeiture dates satisfy the query
              query.where = 'Tract IN (' + tractIDs.join(',') + ')';
              tractsLayer.queryFeatures(query, function(results) {
                let saleType = 'Auction';
                Reports.processClassCities(results, saleType)
                  .then(function(results) {
                    // console.log('results', results);
                    vm.exporting = false;
                    $window.open(results.letter);
                    $window.open(results.list);
                  });
              }, function(error) {
                console.log(error);
              });
            }
          }

          // }
        }, function(error) {
          console.log(error);
        });
      });
    };

    vm.citydirectsale = function() {
      esriLoader.require([
        'esri/layers/FeatureLayer',
        'esri/tasks/query'
      ], function(
        FeatureLayer,
        Query
      ) {
        // find the number of tracts that are available for review
        let query = new Query();
        query.returnGeometry = false;
        query.outFields = ['Acres', 'Legals', 'Political_Sub', 'PhysAddr', 'PhysCity', 'PhysZip', 'PIN', 'PlatDesc', 'Forfeiture_date', 'm_comments', 'Sec', 'Twp', 'Rnge'];
        // let today = new Date();
        query.where = _constructLetterQuery(vm.letterTypeToGenerate.searchFields);
        // query.where = 'TaxForfeitedStatus = \'Active\' AND (Board_Class_Action IS NULL OR Board_Class_Action = \'Non-Conservation\') AND CityTwpResponse IS NULL AND (Political_Sub LIKE \'%CITY%\' OR Political_Sub LIKE \'%TOWNSHIP%\') AND ProposedSaleType = \'Direct Sale\'';
        // get the parcels layers
        let parcelsLayer = maps.getFilterLayer();
        if (parcelsLayer == null) {
          parcelsLayer = new FeatureLayer(appConfig.getConfig().parcelsUrl);
        }

        parcelsLayer.queryFeatures(query, function(results) {
          if (results.features.length === 0) {
            vm.exporting = false;
            setTimeout(function() {
              $scope.$apply();
              alert('There are no features to generate this letter for.');
            }, 200);
          } else {
            let saleType = 'Direct Sale';
            Reports.processClassCities(results, saleType)
              .then(function(results) {
                vm.exporting = false;
                $window.open(results);
              });
          }

          // }
        }, function(error) {
          console.log(error);
        });
      });
    };

    // jshint ignore:start
    function _formatDate(date) {
      return (date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear();
    }
    // jshint ignore:end

    function _filterByFieldValue(fields) {
      let filteredList = [];
      for (let i = 0; i < allLetterTypes.length; i++) {
        if (fields.indexOf(allLetterTypes[i].value) >= 0) {
          filteredList.push(allLetterTypes[i]);
        }
      }
      return filteredList;
    }

    vm.getDomainValues = function(field) {
      // console.log('field', field);
      return _.find(vm.fields, {
        'name': field
      }).domain.codedValues;
    };

    vm.parcelTractFieldSwitch = function() {
      if (vm.letterTypeToGenerate.value === 'dnrlandsalelist') {
        if (vm.parcelOrTract === 'parcels') {
          vm.showTaxStatus = true;
        } else {
          vm.showTaxStatus = false;
        }
      } else if (vm.letterTypeToGenerate.value === 'dnrfutureauction') {
        if (vm.parcelOrTract === 'parcels') {
          vm.showTaxStatus = true;
        } else {
          vm.showTaxStatus = false;
        }
      }
    };


    function _constructLetterQuery(fields) {
      let queryFields = [];
      for (let i = 0; i < fields.length; i++) {
        let queryField = _.find(allFields, {
          'field': fields[i]
        });
        queryField.value = vm[queryField.domValue];
        // console.log('vm[queryField.value] ', vm[queryField.value]);
        queryFields.push(queryField);
      }
      console.log('queryFields', queryFields);
      let wheres = [];
      let polParameter = '';
      for (let id in queryFields) {
        if (queryFields[id].field === 'Political_Sub') {
          if (queryFields[id].value === '') {
            polParameter = '(Political_Sub LIKE \'%CITY%\' OR Political_Sub LIKE \'%TOWNSHIP%\')';
          } else {
            wheres.push(queryFields[id].field + ' = \'' + queryFields[id].value + '\'');
          }
        } else if (queryFields[id].field === 'Forfeiture_date') {
          let forfDate = queryFields[id].value;
          wheres.push('Forfeiture_date <= date \'' + (forfDate.getMonth() + 1) + '/' + forfDate.getDate() + '/' + forfDate.getFullYear() + '\'');
        } else if (queryFields[id].field === 'Last_LS_date'){
          let lsdate = queryFields[id].value;
          wheres.push('Last_LS_date > date \'' + (lsdate.getMonth() + 1) + '/' + lsdate.getDate() + '/' + lsdate.getFullYear() + '\'');
        } else if (queryFields[id].value == null || queryFields[id].value === '') {
          wheres.push(queryFields[id].field + ' IS NULL');
        } else if (queryFields[id].value === 'notnull') {
          wheres.push(queryFields[id].field + ' IS NOT NULL');
        } else if (queryFields[id].value === 'exclude') {
          console.log('EXCLUDE:', queryFields[id].field);
        } else {
          wheres.push(queryFields[id].field + ' = \'' + queryFields[id].value + '\'');
        }
      }
      let where = wheres.join(' AND ');
      if (polParameter !== '') {
        where += ' AND ' + polParameter;
      }
      console.log('where', where);
      return where;
    }


    function _ownerLetterQuery() {
      let wheres = [];
      let whereFields = [{
        field: 'TaxForfeitedStatus',
        value: vm.forfeitStatus
      },{
        field: 'Board_Class_Action',
        value: vm.board
      },{
        field: 'InspectionStatus',
        value: vm.inspection
      },{
        field: 'Tract',
        value: vm.tract
      },{
        field: 'OwnerLetterPrinted',
        value: vm.ownerLetterPrinted
      }];
      for (let id in whereFields) {
        if (whereFields[id].value == null || whereFields[id].value === '') {
          wheres.push(whereFields[id].field + ' IS NULL');
        } else {
          wheres.push(whereFields[id].field + ' = \'' + whereFields[id].value + '\'');
        }
      }
      let where = wheres.join(' AND ');
      console.log('where', where);
      return where;
    }

    // function getFutureAuctionDates() {
    //   esriLoader.require([
    //     'esri/tasks/query',
    //     'esri/tasks/QueryTask'
    //   ], function(
    //     Query,
    //     QueryTask
    //   ) {
    //     // find distinct auction dates
    //     let query = new Query();
    //     query.returnGeometry = false;
    //     query.outFields = ['Last_LS_date'];
    //     query.returnDistinctValues = true;
    //     let today = new Date();
    //     query.where = 'Last_LS_date > \'' + (today.getMonth() + 1) + '/' + today.getDate() + '/' + today.getFullYear() + '\'';
    //     let queryTask = new QueryTask(appConfig.getConfig().parcelsUrl);
    //     queryTask.execute(query, function(results) {
    //       let features = results.features;
    //       let formattedFeatures = [];
    //       for (let feature in features) {
    //         let auctionDate = _formatDate(_formatEsriDate(features[feature].attributes.Last_LS_date)); // jshint ignore:line
    //         formattedFeatures.push(auctionDate);
    //       }
    //       d.resolve(formattedFeatures);
    //     }, function(error) {
    //       console.error('Query error: ', error);
    //     });
    //   });
    // }

    // function _formatDate(date) {
    //   return (date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear();
    // }
    //
    function _formatEsriDate(date) {
      let newDate = new Date(date);
      date = new Date(newDate.getTime() + newDate.getTimezoneOffset() * 60000);
      return date;
    }

  }
})();
